import React from 'react';
import { X, Mail, Phone, Calendar, User, DollarSign, Tag, Clock, Send } from 'lucide-react';

const CRMDetailView = ({ lead, onClose }) => {
  if (!lead) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden" aria-labelledby="slide-over-title" role="dialog" aria-modal="true">
      <div className="absolute inset-0 overflow-hidden">
        {/* Backdrop (Fondo oscuro) */}
        <div 
          className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" 
          onClick={onClose}
        ></div>

        <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
          <div className="pointer-events-auto w-screen max-w-md">
            <div className="flex h-full flex-col overflow-y-scroll bg-white shadow-xl">
              
              {/* Header */}
              <div className="bg-indigo-700 px-4 py-6 sm:px-6">
                <div className="flex items-center justify-between">
                  <h2 className="text-base font-semibold leading-6 text-white" id="slide-over-title">
                    Detalles del Lead
                  </h2>
                  <div className="ml-3 flex h-7 items-center">
                    <button
                      type="button"
                      className="relative rounded-md text-indigo-200 hover:text-white focus:outline-none"
                      onClick={onClose}
                    >
                      <span className="absolute -inset-2.5"></span>
                      <span className="sr-only">Cerrar panel</span>
                      <X size={24} />
                    </button>
                  </div>
                </div>
                <div className="mt-4">
                  <h1 className="text-2xl font-bold text-white">{lead.title}</h1>
                  <p className="text-indigo-200 text-sm mt-1">{lead.contact}</p>
                </div>
              </div>

              {/* Contenido Principal */}
              <div className="relative flex-1 px-4 py-6 sm:px-6">
                
                {/* Acciones Rápidas */}
                <div className="flex space-x-3 mb-8 border-b border-gray-100 pb-6">
                  <button className="flex-1 flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                    <Mail size={16} className="mr-2 text-gray-400" /> Email
                  </button>
                  <button className="flex-1 flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                    <Phone size={16} className="mr-2 text-gray-400" /> Llamar
                  </button>
                  <button className="flex-1 flex items-center justify-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                    <Calendar size={16} className="mr-2 text-gray-400" /> Cita
                  </button>
                </div>

                {/* Propiedades */}
                <div className="grid grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-3 rounded-lg">
                    <div className="flex items-center text-sm text-gray-500 mb-1"><DollarSign size={14} className="mr-1"/> Valor Estimado</div>
                    <div className="font-semibold text-gray-900 text-lg">{lead.value}</div>
                  </div>
                  <div className="bg-gray-50 p-3 rounded-lg">
                    <div className="flex items-center text-sm text-gray-500 mb-1"><Tag size={14} className="mr-1"/> Estado</div>
                    <span className="inline-flex items-center rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10">
                      {lead.status}
                    </span>
                  </div>
                </div>

                {/* Historial de Actividad (Timeline) */}
                <h3 className="font-bold text-gray-900 mb-4 flex items-center"><Clock size={18} className="mr-2"/> Historial</h3>
                <ul className="space-y-6 border-l-2 border-gray-100 ml-2 pl-6 relative">
                  <li className="relative">
                    <span className="absolute -left-[31px] bg-green-100 h-6 w-6 rounded-full flex items-center justify-center border-2 border-white">
                      <div className="h-2 w-2 rounded-full bg-green-500"></div>
                    </span>
                    <p className="text-sm font-medium text-gray-900">Nueva nota creada</p>
                    <p className="text-xs text-gray-500 mt-0.5">Hoy, 10:23 AM por Ana G.</p>
                    <div className="mt-2 text-sm text-gray-600 bg-yellow-50 p-3 rounded border border-yellow-100">
                      El cliente está interesado en la demo técnica para la próxima semana.
                    </div>
                  </li>
                </ul>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CRMDetailView;